var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7903 44.2813C14.7903 48.2763 11.5267 51.5399 7.53195 51.5399C3.5374 51.5399 0.273926 48.2762 0.273926 44.2813C0.273926 40.2869 3.53755 37.0234 7.53195 37.0234H14.7903V44.2813Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4482 44.2813C18.4482 40.2869 21.712 37.0234 25.7066 37.0234C29.7011 37.0234 32.9647 40.2871 32.9647 44.2813V62.4565C32.9647 66.4509 29.701 69.7145 25.7066 69.7145C21.7119 69.7145 18.4482 66.4507 18.4482 62.4565V44.2813Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7066 15.1356C21.7119 15.1356 18.4482 11.8719 18.4482 7.87732C18.4482 3.88277 21.712 0.619141 25.7066 0.619141C29.7011 0.619141 32.9647 3.88292 32.9647 7.87732V15.1356H25.7066Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7068 18.7947C29.7014 18.7947 32.965 22.0583 32.965 26.053C32.965 30.0476 29.7012 33.3109 25.7068 33.3109H7.53195C3.5374 33.3109 0.273926 30.0474 0.273926 26.053C0.273926 22.0582 3.53755 18.7947 7.53195 18.7947H25.7068Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8545 26.053C54.8545 22.0582 58.1178 18.7947 62.1127 18.7947C66.1072 18.7947 69.3705 22.0583 69.3705 26.053C69.3705 30.0476 66.1071 33.3109 62.1127 33.3109H54.8545V26.053Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1957 26.0524C51.1957 30.0469 47.9319 33.3102 43.9374 33.3102C39.9428 33.3102 36.6792 30.0468 36.6792 26.0524V7.87732C36.6792 3.88277 39.943 0.619141 43.9374 0.619141C47.9321 0.619141 51.1957 3.88292 51.1957 7.87732V26.0524Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9374 55.1992C47.9321 55.1992 51.1957 58.4628 51.1957 62.4575C51.1957 66.4519 47.9319 69.7156 43.9374 69.7156C39.9428 69.7156 36.6792 66.4518 36.6792 62.4575V55.1992H43.9374Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9374 51.5399C39.9428 51.5399 36.6792 48.2762 36.6792 44.2813C36.6792 40.2869 39.943 37.0234 43.9374 37.0234H62.1124C66.107 37.0234 69.3703 40.2871 69.3703 44.2813C69.3703 48.2763 66.1068 51.5399 62.1124 51.5399H43.9374Z",
    fill: "#ECB22E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.b2c58442e0f3fa4c50e9517bdea94a0a.svg";
export { ForwardRef as ReactComponent };